
/* 2026-08-24 - two video blocks in this file were replaced. See the bottom of the
   file for the single loader that took their place, and for both originals kept
   verbatim in a comment. The src-override block that used to sit right here is
   gone: it swapped the optimized 480p file in as-home.liquid for a 720p 4.5Mbps
   one and deleted the poster attribute. Nothing else in this file changed. */
(function(){
  var P={fw:{n:'Refresh Face Wash',p:39,img:'--i-fw1'},
         sc:{n:'Sculpting Cream',p:65,img:'--i-sc1'},
         rc:{n:'Recovery Cream',p:60,img:'--i-rc1'}};
  var cart={};
  var bag=document.getElementById('bag'),scrim=document.getElementById('scrim');
  function open(){bag.classList.add('open');scrim.classList.add('on');}
  function close(){bag.classList.remove('open');scrim.classList.remove('on');}
  scrim.addEventListener('click',close);
  document.getElementById('bagClose').addEventListener('click',close);
  document.querySelectorAll('[data-close]').forEach(function(x){x.addEventListener('click',close);});
  /* 2026-08-24 - THE CART WAS NOT THE SAME ON EVERY PAGE.
     #bag lives in sections/as-home.liquid, so it exists ONLY on the homepage,
     and this line bound the bag icon to it. Every other page has no #bag, so
     the icon fell through to the drawer built by as-bag1..5 (#asbag) - two
     different carts depending on where the customer happened to be.
     #asbag is the one on the product pages, and it is now the only one on the
     phone, everywhere. On the desktop tier nothing changes. */
  if (document.documentElement.getAttribute('data-dev') !== 'phone') {
    document.querySelectorAll('.bagn').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();open();});});
  }

  function money(v){return '$'+v.toFixed(2);}
  function count(){var c=0;for(var k in cart)c+=cart[k];return c;}
  function distinct(){var c=0;for(var k in cart)if(cart[k]>0)c++;return c;}
  function raw(){var s=0;for(var k in cart)s+=cart[k]*P[k].p;return s;}
  function ritual(){return cart.fw>0&&cart.sc>0&&cart.rc>0;}
  var SALE={fw:33,sc:65,rc:60};function sraw(){var s=0;for(var k in cart)s+=cart[k]*SALE[k];return s;}function sets(){return Math.min(cart.fw||0,cart.sc||0,cart.rc||0);}function total(){var n=sets(),t=n*123;t+=((cart.fw||0)-n)*SALE.fw+((cart.sc||0)-n)*SALE.sc+((cart.rc||0)-n)*SALE.rc;return t;}function disc(){return raw()-total();}

  function render(){window.__ascart=cart;
    var items=document.getElementById('bagItems'),html='';
    for(var k in cart){ if(!cart[k])continue;
      var pr = SALE[k]<P[k].p
        ? '<s style="color:var(--taupe);opacity:.8">'+money(P[k].p)+'</s>&nbsp;&nbsp;<b style="font-weight:600;color:var(--ink)">'+money(SALE[k])+'</b> each'
        : money(P[k].p)+' each';
      html+='<div class="bagrow"><span class="im" style="background-image:var('+P[k].img+')"></span>'+
      '<div style="flex:1"><b>'+P[k].n+'</b><span class="tiny mut">'+pr+'</span></div>'+
      '<span class="qt"><button data-m="'+k+'">−</button><span>'+cart[k]+'</span>'+
      '<button data-a="'+k+'">+</button></span></div>';
    }
    items.innerHTML=html;
    var has=count()>0;
    document.getElementById('bagEmpty').style.display=has?'none':'block';
    document.getElementById('bagFoot').style.display=has?'block':'none';
    document.getElementById('bagTotal').textContent=money(total());
    var sr=document.getElementById('savedRow');sr.style.display=disc()>0?'flex':'none';sr.querySelector('span').textContent=ritual()?'Ritual pricing (25%)':'Single formula discount (15%)';document.getElementById('savedVal').textContent='−'+money(disc());
    var need=50-raw();
    document.getElementById('freeTxt').textContent='Free shipping included';
    document.getElementById('freePct').textContent=money(raw());
    document.getElementById('freeBar').style.setProperty('--w','100%');
    var missing=['fw','sc','rc'].filter(function(k){return !cart[k];});
    var nd=document.getElementById('nudge');
    if(missing.length&&distinct()>0){
      var sepa=0; missing.forEach(function(k){sepa+=SALE[k];});
      var extra=123-total(); var keep=sepa-extra;
      var cards=missing.map(function(k){
        return '<div class="ups-card"><span class="im" style="background-image:var('+P[k].img+')"></span>'+
               '<b>'+P[k].n+'</b><i>$'+SALE[k]+' on its own</i></div>';}).join('');
      var head=missing.length>1
        ? '<div class="ups-h">Two formulas from<br><span class="ser">the full ritual.</span></div>'
        : '<div class="ups-h">One formula from<br><span class="ser">the full ritual.</span></div>';
      nd.innerHTML='<div class="ups"><div class="ups-eb">Complete the collection</div>'+head+
        '<div class="ups-row">'+cards+'</div>'+
        '<button class="ups-btn" id="upsAdd">Add '+(missing.length>1?'both':P[missing[0]].n)+
        ' — $'+extra+'</button>'+
        '<div class="ups-note">Full price <s>$'+sepa+'</s> · You pay <b>$'+extra+'</b> · You save <b>$'+keep+'</b> · Order total $123</div></div>';
    } else { nd.innerHTML=''; }
    document.querySelectorAll('.bagn i').forEach(function(i){i.textContent=count();});
    document.querySelectorAll('.bagn').forEach(function(b){
      if(!b.querySelector('i')&&count()>0){var i=document.createElement('i');i.textContent=count();b.appendChild(i);}
      if(b.querySelector('i')&&count()===0){b.querySelector('i').remove();}
    });
    document.querySelectorAll('.addbtn').forEach(function(b){
      var k=b.dataset.k;
      if(cart[k]){b.classList.add('in');b.textContent='In your bag ✓';}
      else{b.classList.remove('in');b.textContent='Add to cart';}
    });
    var L=document.getElementById('sbarLeft'),Rr=document.getElementById('sbarRight');if(!L||!Rr)return;
    if(has){L.textContent=count()+' item'+(count()>1?'s':'')+(ritual()?' · ritual −20%':'');
      Rr.innerHTML='<b style="font-weight:500">'+money(total())+'</b>'+(ritual()?' <s style="color:var(--taupe)">$164.00</s>':'');
      document.getElementById('sbarBtn').textContent='View bag & checkout';}
    else{L.textContent='The ritual · 3 formulas';
      Rr.innerHTML='<b style="font-weight:500">$123</b> <s style="color:var(--taupe)">$164.00</s>';
      document.getElementById('sbarBtn').textContent='Add the collection';}
  }
  document.addEventListener('click',function(e){
    var u=e.target.closest('#upsAdd');if(u){['fw','sc','rc'].forEach(function(k){if(!cart[k])cart[k]=1;});render();return;}var t=e.target.closest('[data-a]'); if(t){cart[t.dataset.a]=(cart[t.dataset.a]||0)+1;render();return;}
    var m=e.target.closest('[data-m]'); if(m){var k=m.dataset.m;cart[k]=Math.max(0,(cart[k]||0)-1);if(!cart[k])delete cart[k];render();return;}
    var a=e.target.closest('.addbtn');
    if(a){e.preventDefault();var k=a.dataset.k;cart[k]=(cart[k]||0)+1;render();open();return;}
    if(e.target.closest('#slidesAdd')||e.target.closest('#bannerAdd')||e.target.closest('#stackAdd')||e.target.closest('#addRitual')){e.preventDefault();cart.fw=1;cart.sc=1;cart.rc=1;render();open();return;}
    if(e.target.closest('#sbarBtn')){e.preventDefault();
      if(count()===0){cart.fw=1;cart.sc=1;cart.rc=1;}render();open();return;}
  });
  render();
})();

;
document.addEventListener('click',function(e){var a=e.target.closest('.garr'); if(!a) return;var g=a.closest('.pgal'); var im=[].slice.call(g.querySelectorAll('.pg'));var dt=[].slice.call(g.querySelectorAll('.gdots i'));var i=im.findIndex(function(x){return x.classList.contains('on')});var n=a.classList.contains('gn')?(i+1)%im.length:(i-1+im.length)%im.length;im[i].classList.remove('on'); im[n].classList.add('on');if(dt[i])dt[i].classList.remove('on'); if(dt[n])dt[n].classList.add('on');});
;

;
(function(){document.addEventListener('click',function(e){var b=e.target.closest('.qbuy .qb');if(!b)return;e.preventDefault();e.stopPropagation();var k=b.getAttribute('data-q');var a=document.querySelectorAll('a.addbtn');if(k==='all'){var c=window.__ascart||{};for(var j=0;j<a.length;j++){if(!c[a[j].getAttribute('data-k')])a[j].click();}if(!document.querySelector('.bag.open'))a[0].click();return;}for(var i=0;i<a.length;i++){if(a[i].getAttribute('data-k')===k){a[i].click();break;}}},true);})();
;
(function(){var V={"fw":"46766081769702","sc":"46814024171750","rc":"46819427614950"};function link(){var c=window.__ascart||{},p=[];for(var k in c){if(c[k]>0&&V[k])p.push(V[k]+':'+c[k]);}return p.length?'/cart/'+p.join(','):'/collections/all';}document.addEventListener('click',function(e){var q=e.target.closest('.qbuy .qb');if(q){e.preventDefault();e.stopPropagation();var k=q.getAttribute('data-q');if(k==='all'){location.href='/cart/'+V.fw+':1,'+V.sc+':1,'+V.rc+':1';return;}location.href='/cart/'+V[k]+':1';return;}var t=e.target.closest('.bag .btn.acc,.bag .paybtn');if(!t)return;e.preventDefault();e.stopPropagation();location.href=link();},true);})();
;
(function(){
  var h=document.documentElement;
  function force(){ if(h.getAttribute('data-scheme')!=='light') h.setAttribute('data-scheme','light'); }
  force();
  try{ new MutationObserver(force).observe(h,{attributes:true,attributeFilter:['data-scheme']}); }catch(e){}
  document.addEventListener('shopify:section:load',force);
})();

/* ---------------------------------------------------------------------------
   Homepage film loader. Replaces the src-override block that used to open this
   file and the watchdog that used to close it.

   What was wrong, measured on the preview:
     * the override swapped the 480p 1.5Mbps file that as-home.liquid ships for a
       720p 4.5Mbps one - three times the bytes for a box that paints ~520px wide
       - and then deleted the poster attribute, so there was nothing to look at
       while it buffered.
     * the watchdog ran setInterval(1500) forever and also re-entered go() from
       the 'waiting', 'stalled' and 'pause' handlers. go() calls load(). Calling
       load() restarts the download from byte zero, so every buffering hiccup
       threw away the buffer and started again. Result: readyState stayed at 0
       (HAVE_NOTHING) indefinitely. The video could not finish loading because it
       was continuously being told to start over.
     * both blocks returned early on min-width:1025px, so on desktop nothing ever
       called play() at all and the film just sat there.

   Now: one loader, every width. Play when it is on screen, pause when it is not,
   and never call load() again once a source is attached. 'waiting' and 'stalled'
   are normal buffering signals and are left alone - the browser recovers on its
   own, which it cannot do if we keep resetting it.

   Originals, verbatim:

   (function(){if(window.matchMedia&&matchMedia('(min-width:1025px)').matches)return;var v=document.querySelector('.megaban video.asfilm');if(!v)return;var NEW='https://cdn.shopify.com/videos/c/vp/d62b0af2ac714ef0bb5381ab9f902210/d62b0af2ac714ef0bb5381ab9f902210.HD-720p-4.5Mbps-91492381.mp4';var s=v.querySelector('source');if(s){if(s.getAttribute('src')!==NEW){s.setAttribute('src',NEW);s.setAttribute('type','video/mp4');try{v.load();}catch(e){}}}else{v.setAttribute('src',NEW);try{v.load();}catch(e){}}var p=v.getAttribute('poster');if(p&&p.indexOf('73ad6684')>-1)v.removeAttribute('poster');})();

   (function(){ if(window.matchMedia&&matchMedia('(min-width:1025px)').matches) return;
     var v=document.querySelector('.megaban video.asfilm'); if(!v) return;
     var btn=document.querySelector('.vplay'); var armed=false;
     function go(){ armed=true; if(v.preload!=='auto'){v.preload='auto';try{v.load();}catch(e){}}
       v.muted=true; v.loop=true; v.defaultMuted=true; var p; try{ p=v.play(); }catch(e){}
       if(p&&p.catch) p.catch(function(){ if(btn) btn.classList.remove('off'); }); }
     function near(){ var r=v.getBoundingClientRect(); var vh=window.innerHeight||document.documentElement.clientHeight;
       return r.top < vh+700 && r.bottom > -700; }
     function tick(){ if(near()) go(); }
     v.addEventListener('playing',function(){ if(btn) btn.classList.add('off'); });
     v.addEventListener('pause',function(){ if(armed) setTimeout(go,120); });
     v.addEventListener('ended',function(){ v.currentTime=0; go(); });
     v.addEventListener('error',function(){ if(armed) setTimeout(function(){ try{v.load();}catch(e){} go(); },1500); });
     v.addEventListener('stalled',function(){ if(armed) setTimeout(go,800); });
     v.addEventListener('waiting',function(){ if(armed) setTimeout(go,900); });
     if(btn) btn.addEventListener('click',function(e){ e.preventDefault(); go(); });
     window.addEventListener('scroll',tick,{passive:true});
     window.addEventListener('resize',tick);
     window.addEventListener('touchstart',tick,{passive:true});
     document.addEventListener('visibilitychange',function(){ if(document.visibilityState==='visible') tick(); });
     setTimeout(tick,300); setTimeout(tick,1500);
     setInterval(function(){ if(!armed){ tick(); return; } if(v.paused||v.ended||v.error){ go(); } },1500);
   })();
   --------------------------------------------------------------------------- */
(function(){
  var v=document.querySelector('.megaban video.asfilm');
  if(!v) return;
  var btn=document.querySelector('.vplay');
  var started=false;

  v.muted=true; v.defaultMuted=true; v.loop=true;
  v.setAttribute('muted','');
  v.setAttribute('playsinline','');
  v.setAttribute('webkit-playsinline','');

  function play(){
    try{ var p=v.play(); if(p&&p.catch) p.catch(function(){ if(btn) btn.classList.remove('off'); }); }catch(e){}
  }

  /* attach the source once, and only once */
  function start(){
    if(started) return;
    started=true;
    if(v.preload!=='auto') v.preload='auto';
    if(v.readyState>=2) play();
  }

  v.addEventListener('canplay',function(){ if(started) play(); });
  v.addEventListener('loadeddata',function(){ if(started) play(); });
  v.addEventListener('playing',function(){ if(btn) btn.classList.add('off'); });
  if(btn) btn.addEventListener('click',function(e){ e.preventDefault(); start(); play(); });

  if('IntersectionObserver' in window){
    /* fetch a little before it arrives */
    new IntersectionObserver(function(es,o){
      for(var i=0;i<es.length;i++){ if(es[i].isIntersecting){ start(); o.disconnect(); break; } }
    },{rootMargin:'500px 0px'}).observe(v);
    /* play on screen, pause off screen */
    new IntersectionObserver(function(es){
      for(var i=0;i<es.length;i++){
        if(es[i].isIntersecting){ start(); if(v.paused) play(); }
        else if(!v.paused){ try{ v.pause(); }catch(e){} }
      }
    },{threshold:0.1}).observe(v);
  } else {
    start();
  }

  /* a tab that comes back to the foreground should resume, nothing more */
  document.addEventListener('visibilitychange',function(){
    if(document.visibilityState!=='visible') return;
    var r=v.getBoundingClientRect();
    var vh=window.innerHeight||document.documentElement.clientHeight;
    if(r.top<vh && r.bottom>0){ start(); if(v.paused) play(); }
  });
})();
